import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { logout } from "./Utility";
import toast from 'react-hot-toast';
import customFetch from './apicall/api';

const LoanNocDownload = () => {
    const history = useHistory();
    const location = useLocation();
    const { api_token } = (location && location.state) || {};
    
    const [loanId, setLoanId] = useState('');
    const [loading, setLoading] = useState(false);
    const [validationError, setValidationError] = useState('');

    const validateLoanId = (value) => {
        if (!value) {
            return 'Loan ID is required';
        }
        // Pattern: 2 letters + 3 digits + 2 letters + 6 digits + 1 letter + 2 digits
        // Example: MP008LE001726N01
        const loanIdPattern = /^[A-Z]{2}\d{3}[A-Z]{2}\d{6}[A-Z]\d{2}$/;
        if (!loanIdPattern.test(value)) {
            return 'Invalid Loan ID format. Expected format: MP008LE001726N01';
        }
        return '';
    };

    const handleLoanIdChange = (e) => {
        const value = e.target.value.toUpperCase();
        setLoanId(value);
        // Clear validation error when user types
        if (validationError) {
            setValidationError('');
        }
    };

    const downloadNOC = () => {
        const error = validateLoanId(loanId);
        if (error) {
            setValidationError(error);
            toast.error(error);
            return;
        }

        setLoading(true);

        const requestOptions = {
            method: 'GET',
            headers: {},
        };

        customFetch(
            `${process.env.REACT_APP_DOWNLOAD}forms/loan_no_dues.php?loan_id=${loanId.trim()}`,
            requestOptions
        )
            .then(async (res) => {
                // Check response status and content type
                const contentType = res.headers.get("Content-Type");
                
                // If not OK, check if there's an error message in the response
                if (!res.ok) {
                    // Try to parse JSON error response
                    try {
                        const errorData = await res.json();
                        const errorMessage = errorData.message || errorData.error || 'Unable to download NOC. Please check the Loan ID.';
                        toast.error(errorMessage);
                    } catch {
                        toast.error(`Error ${res.status}: Unable to download NOC. Please check the Loan ID.`);
                    }
                    setLoading(false);
                    return null;
                }
                
                // If content type is not PDF, check if it's JSON with error message
                if (contentType !== "application/pdf") {
                    try {
                        const errorData = await res.json();
                        const errorMessage = errorData.message || errorData.error || 'Please close the loan in the system.';
                        toast.error(errorMessage);
                    } catch {
                        toast.error('please close the loan in the system.');
                    }
                    setLoading(false);
                    return null;
                }
                
                return res.blob();
            })
            .then((blob) => {
                if (blob) {
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", `NOC_${loanId.trim()}.pdf`);
                    document.body.appendChild(link);
                    // Start download
                    link.click();
                    // Clean up and remove the link
                    link.parentNode.removeChild(link);
                    window.URL.revokeObjectURL(url);
                    
                    toast.success('NOC downloaded successfully');
                    setLoading(false);
                }
            })
            .catch((error) => {
                console.log("error", error);
                toast.error('Failed to download NOC. Please try again.');
                setLoading(false);
            });
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            downloadNOC();
        }
    };

    return (
        <div className="container">
            <div className="utr_navbar">
                <button className='button back_button' onClick={() => history.goBack()}>
                    <img
                        src={require("../assets/images/back.png")}
                    />
                </button>
                <h3>Download Loan NOC</h3>
                <button className='button' onClick={logout}>
                    <img
                        src={require("../assets/images/power-off.png")}
                        alt=""
                    />
                </button>
            </div>

            <div className="mt-4 d-flex justify-content-center">
                <div className="row" style={{ width: '100%', maxWidth: '800px' }}>
                    <div className="col-12 col-md-6 mb-3 mb-md-0">
                        <label htmlFor="loanId" style={{ fontWeight: 'bold' }}>
                            Loan ID
                        </label>
                        {validationError && (
                            <div className="invalid-feedback" style={{ display: 'block' }}>
                                {validationError}
                            </div>
                        )}
                        <input
                            id="loanId"
                            type="text"
                            className={`form-control ${validationError ? 'is-invalid' : ''}`}
                            value={loanId}
                            onChange={handleLoanIdChange}
                            onKeyPress={handleKeyPress}
                            placeholder="Enter Loan ID (e.g., MP008LE001726N01)"
                            disabled={loading}
                        />
                    </div>
                    <div className="col-12 col-md-4 d-flex align-items-end">
                        <button
                            className="btn btn-primary w-100"
                            onClick={downloadNOC}
                            disabled={loading || !loanId.trim()}
                        >
                            {loading && (
                                <span
                                    className="spinner-border spinner-border-sm mr-2"
                                    role="status"
                                    aria-hidden="true"
                                />
                            )}
                            {loading ? 'Downloading...' : 'Download NOC (PDF)'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoanNocDownload;
